<div class="details-wrapper">
  @if (!details()) {
    <div class="loading"><nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych kodu..." /></div>
  } @else {
    <div class="details-view">
      <div class="page-header">
        <div class="page-header-icon"><span nz-icon nzType="file-search"></span></div>
        <div>
          <h1>Kod {{ title }}</h1>
          <p>Szczegóły i status weryfikacji kodu</p>
        </div>
      </div>

      <nz-card class="details-card" [nzBordered]="false">
        <div class="card-section-header">
          <span nz-icon nzType="file-text"></span><span>Dane kodu</span>
        </div>
        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Kod</span
            ><nz-tag nzColor="blue">{{ details()?.code }}</nz-tag>
          </div>
          <div class="detail-item">
            <span class="detail-label">Status</span
            ><nz-tag [nzColor]="details()?.isVerified ? 'green' : 'orange'">{{
              verificationStatus()
            }}</nz-tag>
          </div>
          <div class="detail-item wide">
            <span class="detail-label">Nazwa</span
            ><span class="detail-value">{{ details()?.name || '-' }}</span>
          </div>
        </div>
      </nz-card>

      @if (metaSections().length) {
        <section class="additional-section">
          <div class="section-title">
            <span nz-icon nzType="appstore"></span>
            <h2>Dodatkowe</h2>
          </div>

          <div class="meta-sections">
            @for (section of metaSections(); track section.key) {
              <nz-card class="details-card meta-card" [nzBordered]="false">
                <div class="card-section-header">
                  <span nz-icon nzType="tags"></span><span>{{ section.label }}</span>
                </div>
                <div class="meta-items">
                  @for (item of section.items; track item.code) {
                    <div class="meta-item">
                      <nz-tag nzColor="purple">{{ item.code }}</nz-tag>
                      <span>{{ item.name || '-' }}</span>
                    </div>
                  }
                </div>
              </nz-card>
            }
          </div>
        </section>
      }

      <!-- <nz-card class="details-card" [nzBordered]="false" style="display: none">
        <div class="card-section-header">
          <span nz-icon nzType="history"></span><span>Historia zmian</span>
        </div>
        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Utworzył</span
            ><span class="detail-value">{{ details()?.createdByUser || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Zmodyfikował</span
            ><span class="detail-value">{{ details()?.modifiedByUser || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Data modyfikacji</span
            ><span class="detail-value">{{ details()?.modifyDate || '-' }}</span>
          </div>
        </div>
      </nz-card> -->
    </div>

    <div class="button-footer-wrapper">
      <a nz-button nzType="default" [routerLink]="listUrl"
        ><span nz-icon nzType="arrow-left"></span> Wstecz</a
      >
    </div>
  }
</div>
